import { Route, Routes, Outlet, Navigate } from 'react-router-dom';
import { PageLink, PageTitle } from '../../../_dashboard/layout/core';
import { BookingExtraListWrapper } from './booking-extras-list/BookingExtraList';
import { useIntl } from 'react-intl';

const BookingExtraPage = () => {
  const intl = useIntl();

  const bookingExtrasBreadcrumbs: Array<PageLink> = [
    {
      title: intl.formatMessage({ id: 'BOOKING_EXTRA_PAGE.BREADCRUMB' }),
      path: '/apps/booking-extras-management/booking-extras',
      isSeparator: false,
      isActive: false,
    },
    {
      title: '',
      path: '',
      isSeparator: true,
      isActive: false,
    },
  ];

  return (
    <Routes>
      <Route element={<Outlet />}>
        <Route
          path='booking-extras'
          element={
            <>
              <PageTitle breadcrumbs={bookingExtrasBreadcrumbs}>
                {intl.formatMessage({ id: 'BOOKING_EXTRA_PAGE.TITLE' })}
              </PageTitle>
              <BookingExtraListWrapper />
            </>
          }
        />
      </Route>
      <Route index element={<Navigate to='/apps/booking-extras-management/booking-extras' />} />
    </Routes>
  );
};

export default BookingExtraPage;
